// src/components/Programme.jsx
import React from "react";
import illu1 from "../../assets/img/formation/illu1.png";
import illu2 from "../../assets/img/formation/illu2.png";
import qualipoi from "../../assets/img/formation/qualiopi.png";

const ChooseUs = () => {
  return (
    <section className="formation-choose" id="formation-choose">
      <h2>
        POURQUOI CHOISIR
        <span className="br" /> NOS <span>FORMATIONS</span> ?
      </h2>
      <ul>
        <article>
          <div>
            <h3>ADAPTÉES À VOS BESOINS</h3>
            <p>
              Que vous soyez débutant ou expert dans votre domaine, nos
              programmes sont conçus pour s’adapter à vos objectifs
              professionnels.
              <span className="br" />
              Nous proposons des sessions flexibles, en présentiel ou à
              distance, pour s’intégrer au mieux dans votre emploi du temps.
            </p>
          </div>
          <img src={illu1} alt="Sessions adaptées à vos besoins" />
        </article>

        {/* <article className="reverse">
          <div>
            <h3>CERTIFIÉES QUALIOPI</h3>
            <p>
              La certification Qualiopi atteste de la qualité des processus de
              formation mis en place par UP4MIND.
              <span className="br" />
              Elle vous garantit des formations conformes aux exigences des
              financeurs publics et mutualisés, tout en assurant un suivi
              rigoureux et une amélioration continue de nos services.
            </p>
          </div>
          <img src={qualipoi} alt="Logo Qualiopi" />
        </article> */}

        <article className="reverse">
          <div>
            <h3>ACCOMPAGNEMENT SPÉCIALISÉ POUR LES PSH</h3>
            <p>
              Nos programmes sont adaptés aux besoins des personnes en situation
              de handicap, afin de leur offrir un soutien personnalisé.
              <span className="br" />
              En présentiel ou à distance, nous proposons des solutions
              flexibles pour intégrer au mieux la formation à votre quotidien,
              tout en visant vos objectifs professionnels.
            </p>
          </div>
          <img src={illu2} alt="Accompagnement spécialisé PSH" />
        </article>
      </ul>
    </section>
  );
};

export default ChooseUs;
